var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeader2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H5.77778V11.1429H9.33333V6H11.1111V18H9.33333V12.8571H5.77778V18H4V6ZM20 18H14.6667C14.1952 18 13.743 17.8194 13.4096 17.4979C13.0762 17.1764 12.8889 16.7404 12.8889 16.2857C12.8889 15.8314 13.0667 15.4286 13.3689 15.12L17.6978 10.6371C18.0267 10.3286 18.2222 9.9 18.2222 9.42857C18.2222 8.97391 18.0349 8.53788 17.7015 8.21639C17.3681 7.8949 16.9159 7.71429 16.4444 7.71429C15.9729 7.71429 15.5208 7.8949 15.1874 8.21639C14.854 8.53788 14.6667 8.97391 14.6667 9.42857H12.8889C12.8889 8.51926 13.2635 7.64719 13.9303 7.00421C14.5971 6.36122 15.5015 6 16.4444 6C17.3874 6 18.2918 6.36122 18.9586 7.00421C19.6254 7.64719 20 8.51926 20 9.42857C20 10.3714 19.6 11.2286 18.96 11.8543L14.6667 16.2857H20V18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader2);
export default __webpack_public_path__ + "static/media/Header2.5fb3de01ce18cad2e37f95bd8b59c648.svg";
export { ForwardRef as ReactComponent };